import { NotificationsSection } from "@/components/settings";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceSlug/settings/notifications")({
  component: NotificationsSection,
});
